<template>
  <div>
    <div v-if="!stats.length" class="tw-text-muted">No stats</div>
    <div v-else class="tw-overflow-x-auto">
      <table class="bk-table bk-table--compact">
        <thead>
          <tr>
            <th>Batch timestamp</th>
            <th>Result</th>
            <th>Error</th>
            <th>Started</th>
            <th>Ended</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <template v-for="reconcileSource of stats">
            <tr :key="reconcileSource.id">
              <td><display-datetime :datetime="convertBatchIdToTimestamp(reconcileSource.batch_id)" /></td>
              <td>
                <StatusIcon
                  :ok="reconcileSource.result === 'success'"
                  :title="reconcileSource.result === 'success' ? 'All resources fully reconciled' : 'Not all resources fully reconciled'"
                />
              </td>
              <td>{{ reconcileSource.error }}</td>
              <td><display-datetime :datetime="convertBatchIdToTimestamp(reconcileSource.created_at)" /></td>
              <td><display-datetime :datetime="convertBatchIdToTimestamp(reconcileSource.updated_at)" /></td>
              <td>
                <Button
                  :label="reconcileSource.id in expanded ? 'Hide' : 'Detail'"
                  class="p-button-text p-button-sm"
                  @click="expand(reconcileSource.id)"
                />
              </td>
            </tr>
            <tr v-if="reconcileSource.id in expanded" :key="reconcileSource.id + '-detail'">
              <td colspan="6">
                <div class="tw-px-4 tw-py-3">
                  <table class="bk-table">
                    <thead>
                      <tr>
                        <th colspan="2" />
                        <th :colspan="reconcileSource.resources[0].destinations.length" class="tw-text-center">
                          Num records reconciled to destination
                        </th>
                      </tr>
                      <tr>
                        <th>Resource</th>
                        <th>Status</th>
                        <th
                          v-for="destination of reconcileSource.resources[0].destinations"
                          :key="destination.name"
                          class="tw-text-center"
                        >
                          {{ destination.name }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="resource of reconcileSource.resources" :key="resource.name">
                        <td>{{ resource.name }}</td>
                        <td class="tw-text-center">
                          <StatusIcon
                            :ok="resource.is_done"
                            :title="resource.is_done ? 'All destinations fully reconciled' : 'Not all destinations fully reconciled'"
                          />
                        </td>
                        <td
                          v-for="destination of resource.destinations"
                          :key="destination.name"
                          class="tw-text-right"
                        >
                          {{ destination.num_records_reconciled }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { convertBatchIdToTimestamp } from '../../lib/sync/utils/datetime'
import StatusIcon from './StatusIcon'

export default {
  components: { StatusIcon },
  props: {
    stats: Array,
  },
  data() {
    return { expanded: {} }
  },
  methods: {
    convertBatchIdToTimestamp,
    expand(sourceId) {
      if (sourceId in this.expanded) {
        this.$delete(this.expanded, sourceId)
        return
      }
      this.$set(this.expanded, sourceId, true)
    },
  },
}
</script>
